import React, { Component } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"
import EditReviewTypes from "../ReviewTypes/EditReviewTypes"
import moment from "moment"
import DatePicker from "../../../../../../components/common/DatePicker"
import ReviewsReferenceTypes from "../../Reviews/ReviewsTypes/ReviewsReferenceTypes"
import Select from "react-select"
import EmployeeDataTypes from "../../../../Types/EmployeeTypes"
import reviewParams from "../ReviewParams"
import "./AddReview.css"

interface AddReviewProps {
    addReview: Function
    manageParentState: Function
    reference: ReviewsReferenceTypes | null
    employee: EmployeeDataTypes
    contextUser: string | number
    loading: boolean
}

interface AddReviewState {
    review: EditReviewTypes
    eventType: string
}

class AddReview extends Component<AddReviewProps, AddReviewState> {

    required = ["EmployeeReviewTypeId", "ReviewDate", "EmployeeReviewReasonId"]

    state = {
        review: JSON.parse(JSON.stringify(reviewParams)),
        eventType: ""
    }

    manageState = (keys: Array<{ key: string, value?: any }>) => {
        let state: any = this.state
        for (let i = 0; i < keys.length; i++) {
            if (Object.entries(keys[i]).length > 1) {
                state[keys[i].key] = keys[i].value
            } else {
                state[keys[i].key] = !state[keys[i].key]
            }
        }
        this.setState(state)
    }


    handleChange = (event: { target: { value: string } }) => {
        let input = event.target.value
        let review = this.state.review
        let eventType = this.state.eventType
        let eventTypes = Object.keys(review)
        let temp: any = review
        for (let i = 0; i < eventTypes.length; i++) {
            if (eventType === eventTypes[i]) {
                temp[eventTypes[i]] = input
                let param: object = { [eventTypes[i]]: input }
                this.appendParams([param])
            }
        }
    }

    appendParams = (params: Array<object>) => {
        let review = this.state.review
        for (let i = 0; i < params.length; i++) {
            let key = Object.keys(params[i])
            let value = Object.values(params[i])
            if (value[0] !== "") {
                review[key[0]] = value[0]
            } else {
                review[key[0]] = null
            }
        }
        this.manageState([{ key: "review", value: review }])
    }

    addReview = () => {
        let props = this.props
        let rb = this.state.review
        rb.EmployeeId = props.employee.UserId
        //@ts-ignore
        rb.CurrentJobTitleId = this.getJobTitleId(props.employee.JobTitle)
        rb.NewJobTitleId = rb.CurrentJobTitleId
        rb.EmployeeReviewStatusId = 1
        rb.ProfitCenterId = props.employee.HomeProfitCenterId
        rb.ReviewDate = moment(rb.ReviewDate).format().split("T")[0]
        rb.CreatedBy = props.contextUser
        this.props.addReview(rb)
        this.manageState([{ key: "review", value: reviewParams }])
    }

    getStuffThatTheAPIShouldBeDoingInstead = (key1: string, key2: string, key3: string, key4: string) => {
        //@ts-ignore
        const referenceItem: Array<{ id: number, text: string }> = this.props.reference[key1]
        const value = this.state.review[key2]
        for (let i = 0; i < referenceItem.length; i++) {
            //@ts-ignore
            if (value === referenceItem[i][key3]) {
                //@ts-ignore
                return referenceItem[i][key4]
            }
        }
        return null
    }

    getJobTitleId = (title: string) => {
        let reference = this.props.reference
        if (reference) {
            for (let i = 0; i < reference.jobTitles.length; i++) {
                if (title === reference.jobTitles[i].text) {
                    return reference.jobTitles[i].id
                }
            }
        }
        return null
    }

    filterReferenceByReferenceID = (key1: string, key2: string) => {
        //@ts-ignore
        const obj = this.props.reference[key1]
        const review = this.state.review
        let reference = []
        for (let i = 0; i < obj.length; i++) {
            //@ts-ignore
            if (obj[i].referenceId === review[key2]) {
                reference.push(obj[i])
            }
        }
        return reference
    }

    canSubmit = () => {
        const required = this.required
        const review = this.state.review
        for (let i = 0; i < required.length; i++) {
            if (!review[required[i]]) {
                return false
            }
        }
        return true
    }

    render() {

        const props = this.props
        const review = this.state.review

        // //console.log("review", review)
        // //console.log("employee", employee)
        // //console.log("reference:", props.reference)

        return (
            <div className="AddReview">
                <Modal id="add-review-modal"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                >
                    <Modal.Header>
                        <div className="AddReviewModalHeader">
                            <p>Create a review</p>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="AddReviewModalBody">
                            <div className="AddReviewModalBodyColumn">
                                <p>Review Date:</p>
                                <DatePicker
                                    onChange={(date: number) => {
                                        this.appendParams([{ ReviewDate: moment(date.valueOf()).format().split("T")[0] }])
                                    }}
                                    value={review.ReviewDate || ""}
                                    useCloseCallback={true}
                                />
                            </div>
                            {props.reference && <div className="AddReviewModalBodyColumn">
                                <p>Review Type:</p>
                                <Select
                                    //@ts-ignore
                                    value={{ label: this.getStuffThatTheAPIShouldBeDoingInstead("employeeReviewTypes", "EmployeeReviewTypeId", "id", "text") || "*NA*" }}
                                    options={props.reference.employeeReviewTypes.map((s) => ({ value: s.id, label: s.text }))}
                                    onChange={(item: any) => {
                                        this.appendParams([{ EmployeeReviewTypeId: item.value }, { EmployeeReviewReasonId: null }])
                                    }}
                                />
                            </div>}
                            {props.reference && <div className="AddReviewModalBodyColumn">
                                <p>Review Reason:</p>
                                <Select
                                    //@ts-ignore
                                    value={{ label: this.getStuffThatTheAPIShouldBeDoingInstead("employeeReviewReason", "EmployeeReviewReasonId", "id", "text") || "*NA*" }}
                                    options={this.filterReferenceByReferenceID("employeeReviewReason", "EmployeeReviewTypeId").map((item) => ({ value: item.id, label: item.text }))}
                                    onChange={(item: any) => {
                                        this.appendParams([{ EmployeeReviewReasonId: item.value }])
                                    }}
                                />
                            </div>}
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="AddReviewModalFooter">
                            {!props.loading && <Button id="add-review-modal-footer-modal-back-btn" variant="secondary" onClick={() => props.manageParentState([{ key: "addReview" }])}>Back</Button>}
                            {!props.loading && <Button id="add-review-modal-footer-modal-create-btn" disabled={!this.canSubmit()} onClick={() => this.addReview()}>Create</Button>}
                            {props.loading && <Spinner id="loading-add-review-spinner" animation="border" />}
                        </div>
                    </Modal.Footer >
                </Modal >
            </div >
        )
    }
}

export default AddReview